/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactEmail
 */
export interface ContactEmail {
    /**
     * 
     * @type {string}
     * @memberof ContactEmail
     */
    email?: string;
}

export function ContactEmailFromJSON(json: any): ContactEmail {
    return ContactEmailFromJSONTyped(json, false);
}

export function ContactEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function ContactEmailToJSON(value?: ContactEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}


